import { IVariant } from "../../interfaces";
import { pressuredStationPriceProvider } from "../../providers/pressuredStationProvider";
import { getPrice, getWidths, getPriceHeader } from "../price";
import { getItemMargin, getOstr } from "../utils";

const getPressuredStation = (variant: IVariant) => {
  const filtered = variant.pressuredStation.filter((g) => g.quantity > 0);

  // Skip
  if (filtered.length === 0) {
    return [];
  }

  return [
    {
      stack: [
        { text: "Kanalizace tlaková - čerpací stanice u RD", style: "h4" },
        {
          layout: "lightHorizontalLines",
          table: {
            widths: getWidths(2),
            body: [
              [
                { text: "Název větve", style: "tableHeader" },
                { text: "Počet", style: "tableHeader" },
                ...getPriceHeader(),
              ],
              ...filtered.map((g) => [
                getOstr(g.name),
                g.quantity,
                ...getPrice(g, pressuredStationPriceProvider),
              ]),
              ["", "", "", ""],
              [
                "Celkový součet",
                "",
                ...getPrice(filtered, pressuredStationPriceProvider),
              ],
            ],
          },
        },
      ],
      unbreakable: true,
      ...getItemMargin(),
    },
  ];
};

export default getPressuredStation;
